import type { PresentationScalar } from './PresentationScalar'
import type { TranslateFn } from './TranslateFn'
import { resolveCode } from './resolveCode'
import { resultCodeResolverMap } from './resultCodeResolverMap'
import type { ResultCode } from './ResultCode'

interface ResultLike {
  code: string
  params?: Record<string, PresentationScalar>
}

function isResultCode(code: string): code is ResultCode {
  return Object.hasOwn(resultCodeResolverMap.byCode, code)
}

// The OpenAPI contract types `result_code`/`result_params.entity_type` as
// generic strings (not literals) for several dashboard mutation operations,
// so the guard above narrows the runtime value before resolving.
export function resolveResultMessage(result: ResultLike, t: TranslateFn): string {
  if (!isResultCode(result.code)) return t('presentation.results.genericCompleted')

  return resolveCode(
    { code: result.code, ...(result.params !== undefined ? { params: result.params } : {}) },
    resultCodeResolverMap,
    t
  )
}
